import { Component, Children, type ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { size } from '../../../../../common/css/setting/variable';

import ErrorBoundaryWrapper from '../../../../../common/handler/ErrorBoundaryWrapper';

type RuleSet = ReturnType<typeof css>;

const Wrapper = styled.div<{
  readonly $isOneColumnPage: IProps['isOneColumnPage'];
  readonly $overWriteStyle?: RuleSet;
}>`
  flex: 1;
  /* flexで要素が親要素をぶち抜く時の対策 */
  /* 参考：https://kudakurage.hatenadiary.com/entry/2016/04/01/232722 */
  min-width: 0;
  max-width: ${({ $isOneColumnPage }) => ($isOneColumnPage ? 'none' : size.width_mainColumnWithBorder_pc)};

  /* IE11バグ回避 参考:https://parashuto.com/rriver/development/flexbugs-ie11-box-sizing-ignored-in-flex-basis */
  *::-ms-backdrop {
    flex: 1 1 auto;
    width: ${size.width_mainColumnWithBorder_pc};
  }

  ${({ $overWriteStyle }) => !!$overWriteStyle && $overWriteStyle}
`;

const Inner = styled.div`
  margin-top: -1px;
  background-color: ${props => props.theme.news.palette.bg_lv1_common};
  border: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
`;

interface IProps {
  readonly appendElement?: ReactElement;
  readonly isOneColumnPage?: boolean;
  readonly children?: React.ReactNode;
  readonly overWriteStyle?: RuleSet;
}

interface IDefaultProps {
  isOneColumnPage: boolean;
}

export default class MainFrame extends Component<IProps> {
  public static defaultProps: IDefaultProps = {
    isOneColumnPage: false
  };
  /**
   *
   */
  public render() {
    const wrapped = Children.map(this.props.children, child => <ErrorBoundaryWrapper component={child} />);

    // 他の箇所を含めyjnMainのStyledComponet移行が完了したらclassを削除できる
    return (
      <Wrapper
        id="yjnMain"
        className={this.props.isOneColumnPage ? 'oneColumn' : ''}
        $isOneColumnPage={this.props.isOneColumnPage}
        $overWriteStyle={this.props.overWriteStyle}
      >
        <Inner id="contentsWrap">{wrapped}</Inner>
        {this.props.appendElement}
      </Wrapper>
    );
  }
}
